"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteQueryInvoker = void 0;
const index_1 = require("../index");
/**
 * RPC Query Invoker
 */
class RemoteQueryInvoker extends index_1.RemoteInvocationInvoker {
    /**
     * Execute method is a higher API method for invoking remote queries that will:
     * - Raise an exception on request or execution failures
     * - Raise an exception if the given query is not valid
     * - Return the ExecutionResult instead of the InvocationResult
     */
    invoke(queryOrType, dataOrContext, context) {
        if (typeof queryOrType === "function") {
            return super.invoke(queryOrType, dataOrContext, context);
        }
        else {
            return super.invoke(queryOrType, dataOrContext);
        }
    }
}
exports.RemoteQueryInvoker = RemoteQueryInvoker;
//# sourceMappingURL=RemoteQueryInvoker.js.map